import { Maybe } from '@aibees/shared/definition';
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<{
  hideHeader: Maybe<boolean>;
}> = ({ hideHeader }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderTopLeftRadius: !hideHeader ? (p: any) => p.spacing(1) : 'unset',
  borderTopRightRadius: !hideHeader ? (p: any) => p.spacing(1) : 'unset',
});

export const panel: SxStyleFunc<Maybe<boolean>> = (hideHeader) => ({
  border: hideHeader ? 'none' : 'default',
});

export const cardBox: SxStyle = (isPeople) => ({
  gap: '0!important',
  borderWidth: isPeople ? 'unset' : '1px',
  borderStyle: isPeople ? 'none' : 'solid',
  borderColor: isPeople ? 'unset' : (p) => p.palette.primary[100],
  borderRadius: isPeople ? 'unset' : (p) => p.spacing(1),
});

export const headerWrapper: SxStyleFunc<boolean | undefined> = (isPeople) => ({
  background: isPeople ? 'none' : (p) => p.palette.primary[50],
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.primary[100],
});

export const content: SxStyle = {
  gap: (p) => p.spacing(1),
  p: 0,
};

export const container: SxStyle = {
  '& > div:not(:last-child)': {
    borderBottom: (p) => `1px solid ${p.palette.grey[300]}`,
  },
};

export const line: SxStyle = {
  borderStyle: 'solid',
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  color: (p) => p.palette.primary[600],
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: (p) => p.spacing(1.5),
  padding: (p) => p.spacing(1.5),
  '& > div:first-of-type': {
    flexShrink: 0,
  },
  '& > div:last-of-type': {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    justifyContent: 'flex-end',
  },
};

export const titleRow: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  '&.MuiButton-text': {
    textTransform: 'none',
  },
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body4,
  color: (p) => p.palette.common.black,
  fontWeight: 700,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: (p) => p.spacing(25),
};
